import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { TenantProvider } from './contexts/TenantContext'
import { ProgramProvider } from './contexts/ProgramContext'
import { LogicModelProvider } from './contexts/LogicModelContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import { 
  LoginPage, 
  VerifyPage, 
  DashboardPage, 
  SettingsPage 
} from './pages'
import { 
  ProgramsListPage, 
  ProgramDetailPage, 
  ProgramCreatePage, 
  ProgramEditPage 
} from './pages/programs'
import { OrganizationSettings } from './pages/settings/OrganizationSettings'
import { LogicModelWizard } from './components/logic-model'

function AppContent() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      
      {/* Protected routes */}
      <Route path="/" element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      } />
      
      {/* Programs routes */}
      <Route path="/programs" element={
        <ProtectedRoute>
          <ProgramsListPage />
        </ProtectedRoute>
      } />
      <Route path="/programs/new" element={
        <ProtectedRoute>
          <ProgramCreatePage />
        </ProtectedRoute>
      } />
      <Route path="/programs/:id" element={
        <ProtectedRoute>
          <ProgramDetailPage />
        </ProtectedRoute>
      } />
      <Route path="/programs/:id/edit" element={
        <ProtectedRoute>
          <ProgramEditPage />
        </ProtectedRoute>
      } />
      
      {/* Logic Model routes */}
      <Route path="/programs/:programId/logic-model/new" element={
        <ProtectedRoute>
          <LogicModelProvider>
            <LogicModelWizard />
          </LogicModelProvider>
        </ProtectedRoute>
      } />
      <Route path="/programs/:programId/logic-model/:logicModelId" element={
        <ProtectedRoute>
          <LogicModelProvider>
            <LogicModelWizard />
          </LogicModelProvider>
        </ProtectedRoute>
      } />
      
      {/* Settings routes */}
      <Route path="/settings" element={
        <ProtectedRoute>
          <SettingsPage />
        </ProtectedRoute>
      } />
      <Route path="/settings/organization" element={
        <ProtectedRoute>
          <OrganizationSettings />
        </ProtectedRoute>
      } />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <TenantProvider>
        <ProgramProvider>
          <AppContent />
        </ProgramProvider>
      </TenantProvider>
    </AuthProvider>
  )
}

export default App
